import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  overflow: "scroll",
  height: "90%",
  marginTop: "1%",
  marginBottom: "2%",
};

export default function BasicModal(props) {
  let { onClose, open, children } = props;

  return (
    <div>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="2xl:w-[50%] xl:w-[50%] lg:w-[50%] w-[90%]">
          {children}
        </Box>
      </Modal>
    </div>
  );
}
